<template>
    <div class="gateway_main" :class="{'cn':version == '1'}">
        <div class="gateway_left">
            <!-- <side-bar></side-bar> -->
        </div>
        <div class="gateway_right">
            <div class="gateway_right_top">
                <div class="right_top_l">
                    <el-select v-model="buildId">
                        <el-option
                            v-for="item in buildNav"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-input :placeholder="$t('App.gateway.text1')" v-model="keywords" @keyup.native="getGatewayListKeyUp($event)" class="input-with-select">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="getGatewayList()"></i>
                    </el-input>
                </div>
            </div>
            <div class="gateway_right_main">
                <div class="main_top">
                    <div class="main_top_l">
                        <div class="div1"><span>{{$t('App.sideBar.text10')}}</span></div>
                        <div class="div2">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('App.lights.text10')}}</el-checkbox>
                            <div class="btn" @click="postDelLight(checkList,'batch')">
                                <i class="iconfont icon-delete"></i>
                                <span>{{$t('App.lights.text1')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="main_top_r">
                        <div class="btn" @click="addGatewayFun()"><img :src="img_gateway_icon"><span>{{$t('App.gateway.text2')}}</span></div>
                    </div>
                </div>
                <div class="main_cont">
                    <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
                        <el-table
                            ref="gatewayDataList"
                            v-loading="loading.gatewayDataList"
                            height="100%"
                            :data="gatewayDataList">
                            <el-table-column
                                :label="$t('App.lights.text33')"
                                :prop="'index'"
                                align="left"
                                header-align="center"
                                :width="6*remRatio">
                                <template slot-scope="scope">
                                    <el-checkbox :label="scope.row.id" :key="scope.row.id">{{scope.row.webIndex}}</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="$t('App.room.text42')"
                                :prop="'network_name'"
                                align="left"
                                :show-overflow-tooltip="true"
                                :min-width="7*remRatio">
                            </el-table-column>
                            <el-table-column
                                :label="$t('App.room_light.text58')"
                                :prop="'gatewayId'"
                                align="center"
                                :show-overflow-tooltip="true"
                                :min-width="7*remRatio">
                            </el-table-column>
                            <el-table-column
                                v-for="(item) in gatewayArr"
                                :key="'table_'+item.prop"
                                :prop="item.prop"
                                :label="item.label"
                                :align="item.align?item.align:'center'"
                                :width="item.width"
                                :show-overflow-tooltip="true"
                                :min-width="item.minWidth">
                                    <template slot-scope="scope">
                                        <div v-if="item.type != 1">{{scope.row[item.prop]}}</div>
                                        <div v-if="item.prop == 'online'" class="online">
                                            <i v-if="scope.row.online=='0'" class="iconfont icon-disconnect"></i>
                                            <i v-if="scope.row.online=='1'" class="iconfont icon-wifi" style="color: #3edd6b;"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                align="center"
                                :min-width="12*remRatio"
                                :label="$t('App.lights.text6')">
                                <template slot-scope="scope">
                                    <span class="btn" @click="editFun(scope.row)" :title="$t('App.lights.text7')">
                                        <i class="iconfont icon-bianji"></i>
                                    </span>
                                    <span class="btn" @click="upgradeFun(scope.row)" :title="$t('App.lights.text9')">
                                        <i class="iconfont icon-gujianbanbenshengji"></i>
                                    </span>
                                    <span class="btn" @click="openWifiFun(scope.row)" :title="$t('App.gateway.text3')">
                                        <i class="iconfont icon-wifi1"></i>
                                    </span>
                                    <span class="btn" @click="networkingFun(scope.row)" :title="$t('App.gateway.text4')">
                                        <i class="iconfont icon-wangguanpeizhi"></i>
                                    </span>
                                    <span class="btn" @click="postDelLight(scope.row)" :title="$t('App.lights.text1')">
                                        <i class="iconfont icon-delete"></i>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-checkbox-group>
                    <div class="pagination_box">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!-- 添加网关 -->
        <div class="gateway_wrap scrollbar_style" v-show="gatewayTkShowbg">
            <div class="gateway_wrap_bg" @click="gatewayTkClose()"></div>
            <div class="gateway_box" :class="{'gateway_tk_show':gatewayTkShow}">
                <div class="gateway_title">
                    <span class="span1">{{$t('App.gateway.text5')}}</span>
                    <span class="span2" @click="gatewayTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="form">
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text42')}}</span>
                        <el-input v-model="gatewayForm.network_name" placeholder=""></el-input>
                    </div>
                    <div class="form_item" v-if="version == 1">
                        <span class="laber">{{$t('App.room.text79')}}</span>
                        <!-- <el-input v-model="gatewayForm.type" placeholder=""></el-input> -->
                        <el-dropdown @command="commandType" trigger="click" @visible-change="commandHide('dropdown_gateway_type')">
                            <span class="span1">{{gatewayFormType}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_gateway_type">
                                <el-dropdown-item v-for="item in formTypeNav" :command="item" :key="'floor'+item.id" :class="{'select':item.id==gatewayForm.type}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text29')}}</span>
                        <el-dropdown @command="commandFloor" trigger="click" @visible-change="commandHide('dropdown_gateway_floor')">
                            <span class="span1">{{gatewayFormFloorName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_gateway_floor">
                                <el-dropdown-item v-for="item in floorNav" :command="item" :key="'floor'+item.id" :class="{'select':item.id==gatewayForm.floorId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text30')}}</span>
                        <el-dropdown @command="commandRoom" trigger="click" @visible-change="commandHide('dropdown_gateway_room')">
                            <span class="span1">{{gatewayFormRoomName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_gateway_room">
                                <el-dropdown-item v-for="item in roomNav" :command="item" :key="'room'+item.id" :class="{'select':item.id==gatewayForm.roomId}">{{item.number}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.gateway.text6')}}</span>
                        <el-input v-model="gatewayForm.gatewayId" placeholder=""></el-input>
                    </div>
                    <div class="form_item" v-if="gatewayForm.type != 1">
                        <span class="laber">{{$t('App.gateway.text7')}}</span>
                        <el-dropdown @command="commandInspecTime" trigger="click" @visible-change="commandHide('dropdown_gateway_inspecTime')" v-if="gatewayOnline == '1'">
                            <span class="span1">{{gatewayFormInspecTime}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_gateway_inspecTime">
                                <el-dropdown-item v-for="item in inspecTimeNav" :command="item" :key="'room'+item.id" :class="{'select':item.id==gatewayForm.inspecTime}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-input v-model="gatewayFormInspecTime" v-if="gatewayOnline == '0'" disabled></el-input>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSaveGateway()">{{$t('App.room.text35')}}</div>
                </div>
            </div>
        </div>
        <!-- 网关升级 -->
        <div class="gatewayUpdate_wrap scrollbar_style" v-show="gatewayUpdateTkShowbg">
            <div class="gatewayUpdate_wrap_bg" @click="gatewayUpdateTkClose()"></div>
            <div class="gatewayUpdate_box" :class="{'gateway_tk_show':gatewayUpdateTkShow}">
                <div class="gatewayUpdate_title">
                    <span class="span1">{{$t('App.lights.text20')}}</span>
                    <span class="span2" @click="gatewayUpdateTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="box1">
                   <div><img src="../img/upgrade.png"></div>
                   <div><span>{{gatewayUpdateSoftware}}</span></div>
                </div>
                <p class="p1">{{$t('App.lights.text21')}}</p>
                <div class="btn_box">
                    <div class="btn" v-if="gatewayUpdateType == '1'" @click="gatewayUpdateFun()">{{$t('App.room.text59')+' '+gatewayUpdateVersion}}</div>
                    <el-progress :stroke-width="null" :percentage="uploadGatewayVal" :text-inside="true" v-if="gatewayUpdateType == '2'" v-loading="gatewayUpdateType =='2'"></el-progress>
                    <div class="text" :class="gatewayUpdateStatus=='0'?'span1':'span2'" v-if="gatewayUpdateType == '3'" @click="gatewayUpdateFun()">
                        <span v-if="gatewayUpdateStatus == '0'" class="span1">{{$t('App.lights.text22')}}</span>
                        <span v-if="gatewayUpdateStatus == '1'" class="span2">{{$t('App.lights.text23')}}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 网关链接 -->
        <div class="networking_wrap scrollbar_style" v-show="networkingTkShowbg">
            <div class="networking_wrap_bg" @click="networkingTkClose()"></div>
            <div class="networking_box" :class="{'gateway_tk_show':networkingTkShow}">
                <div class="networking_title">
                    <span class="span1">{{$t('App.gateway.text8')}}</span>
                    <span class="span2" @click="networkingTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="box1">
                   <div class="btn" :class="{'select':networkingType == '1'}" @click="networkingTypeFun('1')">{{$t('App.gateway.text9')}}</div>
                   <div class="btn" :class="{'select':networkingType == '2'}" @click="networkingTypeFun('2')">{{$t('App.gateway.text10')}}</div>
                   <div class="btn" :class="{'select':networkingType == '3'}" @click="networkingTypeFun('3')">{{$t('App.gateway.text27')}}</div>
                </div>
                <div class="refresh_box">
                    <el-button v-if="(networkingType==1&&connectList.length != 0)||(networkingType==2&&devicesList.length != 0)||(networkingType==3&&devices_485_List.length != 0)" icon="el-icon-refresh" circle @click="getDevicesList(gateway,networkingType)"></el-button>
                </div>
                <div class="networkingType_1" v-if="networkingType == '1'" :class="{'null':connectList.length == 0}" >
                    <div class="no_devices" v-if="connectList.length == 0">
                        <div class="img_box">
                            <img src="../img/no_devices.png">
                        </div>
                        <p>{{$t('App.gateway.text12')}}</p>
                        <div class="btn" @click="getDevicesList(gateway,'1')" v-loading="loading.connectList">search</div>
                    </div>
                    <div class="list scrollbar_style" v-loading="loading.connectList">
                        <div class="li" v-for="item in connectList" :key="item.deviceId">
                            <div class="l">
                                <div class="img_box">
                                    <img :src="require('../img/device_'+item.type+'_2'+img_str+'.png')" v-if="item.id&&item.type<4">
                                </div>
                                <div class="text_box" style="width: calc(100% - 9rem);">
                                    <p class="p1"><span class="span1">{{item.id?item.name:$t('App.gateway.text11')}}</span></p>
                                    <p class="p2"><span class="span2" :title="item.deviceId">ID-{{item.deviceId}}</span></p>
                                </div>
                            </div>
                            <div class="r">
                                <el-cascader :options="devTypeOptions" :show-all-levels="false" v-model="item.devType" @change="devTypeChange(item)" v-if="item.type>=4" v-loading="item.devTypeLoading"></el-cascader>
                                <div class="btn btn2" :class="{'select':item.status == '1'}" v-loading="item.loading2" @click="statusControl(item)" v-if="item.id&&(item.type =='0'||item.type =='1')"><i class="iconfont icon-liangdeng"></i></div>
                                <div class="btn btn1" @click="addNetLamp(item,'0')" v-loading="item.loading1"><i class="iconfont icon-duankai"></i></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="networkingType_2" v-if="networkingType == '2'" :class="{'null':devicesList.length == 0}">
                    <div class="no_devices" v-if="devicesList.length == 0">
                        <div class="img_box">
                            <img src="../img/no_devices.png">
                        </div>
                        <p>{{$t('App.gateway.text12')}}</p>
                        <div class="btn" @click="getDevicesList(gateway,'2')" v-loading="loading.devicesList">{{$t('App.gateway.text26')}}</div>
                    </div>
                    <div class="list scrollbar_style" v-if="devicesList.length > 0" v-loading="loading.devicesList">
                        <div class="li" v-for="item in devicesList" :key="item.deviceId">
                            <div class="l">
                                <div class="img_box">
                                    <div class="img_box_">
                                        <img :src="require('../img/device_'+item.type+'_2'+img_str+'.png')" v-if="item.id&&item.type<4">
                                    </div>
                                    <div class="icon">
                                        <!-- <img src="../img/lanya_1.png"> -->
                                        <img src="../img/lanya_2.png">
                                    </div>
                                    <!-- <i class="iconfont icon-xinhao_ruo"></i> -->
                                </div>
                                <div class="text_box" style="width: calc(100% - 9rem);">
                                    <p class="p1"><span class="span1">{{item.id?item.name:$t('App.gateway.text11')}}</span></p>
                                    <p class="p2"><span class="span2" :title="item.deviceId">ID-{{item.deviceId}}</span></p>
                                </div>
                            </div>
                            <div class="r">
                                <div class="btn btn1" :class="{'select':item.bind == '1'}" v-loading="item.loading1" @click="addNetLamp(item,'1')"><i class="iconfont icon-pipeilianjie"></i></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="networkingType_3" v-if="networkingType == '3'" :class="{'null':devices_485_List.length == 0}">
                    <div class="no_devices" v-if="devices_485_List.length == 0">
                        <div class="img_box">
                            <img src="../img/no_devices.png">
                        </div>
                        <p>{{$t('App.gateway.text12')}}</p>
                        <div class="btn" @click="getDevicesList(gateway,'3')" v-loading="loading.devices_485_List">search</div>
                    </div>
                    <div class="list scrollbar_style" v-if="devices_485_List.length > 0" v-loading="loading.devices_485_List">
                        <div class="li" v-for="item in devices_485_List" :key="item.deviceId">
                            <div class="l">
                                <div class="img_box">
                                    <div class="img_box_">
                                        <img :src="require('../img/device_'+item.type+'_2'+img_str+'.png')" v-if="item.id&&item.type<4">
                                    </div>
                                    <div class="icon">
                                        <!-- <img src="../img/lanya_1.png"> -->
                                        <img src="../img/lanya_2.png">
                                    </div>
                                    <!-- <i class="iconfont icon-xinhao_ruo"></i> -->
                                </div>
                                <div class="text_box" style="width: calc(100% - 9rem);">
                                    <p class="p1"><span class="span1">{{item.id?item.name:$t('App.gateway.text11')}}</span></p>
                                    <p class="p2"><span class="span2" :title="item.deviceId">ID-{{item.deviceId}}</span></p>
                                </div>
                            </div>
                            <div class="r">
                                <div class="btn btn1" :class="{'select':item.bind == '1'}" v-loading="item.loading1" @click="addNetLamp(item,'1')"><i class="iconfont icon-pipeilianjie"></i></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- wifi -->
        <div class="wifi_wrap scrollbar_style" v-show="wifiTkShowbg">
            <div class="wifi_wrap_bg" @click="wifiTkClose()"></div>
            <div class="wifi_box" :class="{'wifi_tk_show':wifiTkShow}">
                <div class="wifi_title">
                    <span class="span1">{{$t('App.gateway.text3')}}</span>
                    <span class="span2" @click="wifiTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="box1">
                   <div v-if="wifiText1 != $t('App.gateway.text23')"><img src="../img/upgrade.png"></div>
                   <div v-if="wifiText1 == $t('App.gateway.text23')"><img src="../img/wifi.png"></div>
                   <div><span>{{wifiText1}}</span></div>
                </div>
                <div class="form_item">
                    <span class="laber">{{$t('App.gateway.text13')}}</span>
                    <el-select v-model="wifiSsidForm.wifiName" :filterable="true" :allow-create="true">
                        <el-option
                          v-for="(item,index) in wifiSsidNav"
                          :key="item+index"
                          :label="item"
                          :value="item">
                        </el-option>
                    </el-select>
                    <!-- <el-dropdown @command="wifiSsidCommand" trigger="click" @visible-change="commandHide('dropdown_wifi_ssid')" v-loading="loading.getWifiList">
                        <span class="span1">{{wifiSsidForm.wifiName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                        <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_wifi_ssod">
                            <el-dropdown-item v-for="(item,index) in wifiSsidNav" :command="item" :key="'wifi'+index" :class="{'select':item==wifiSsidForm.wifiName}">{{item}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown> -->
                </div>
                    <div class="form_item" :style="{'opacity':(wifiType == '3'&&wifiStatus == '1')?0:1}">
                        <span class="laber">{{$t('App.gateway.text14')}}</span>
                        <el-input v-model="wifiSsidForm.wifiPw" placeholder=""></el-input>
                    </div>
                <div class="update_box" :style="{'opacity':(wifiType == '3'&&wifiStatus == '1')?0:1}">
                    <div class="btn" v-if="wifiType == '1'" @click="wifiFun()" v-loading="loading.wifiFun">{{'Connect'}}</div>
                    <p class="p1" v-if="loading.wifiFun">{{$t('App.gateway.text15')}}</p>
                    <div class="text" :class="wifiStatus=='0'?'span1':'span2'" v-if="wifiType == '3'" @click="wifiFun()">
                        <span v-if="wifiStatus == '0'" class="span1">{{$t('App.gateway.text16')}}</span>
                        <span v-if="wifiStatus == '1'" class="span2"><i class="iconfont icon-gou"></i>{{$t('App.gateway.text17')}}</span>
                    </div>
                </div>
                <div class="btn_box" v-if="wifiType == '3'&&wifiStatus == '1'">
                    <div class="btn" @click="switchWifiFun()">{{$t('App.gateway.text18')}}</div>
                </div>
            </div>
        </div>

    </div>
</template>

<script type="text/javascript">
    // import sideBar from '../components/sideBar.vue'
    import { mapGetters } from 'vuex'
    import allUrl from '../api/allUrl.js'
    import base from '../api/base.js'
    export default {
        name:'gateway',
        data () {
            return{
                formTypeNav:[],

                buildId:'',
                buildNav:[],
                keywords:'',
                floorNav:[],
                roomNav:[],

                checkAll:false,
                isIndeterminate:false,
                checkList:[],

                gatewayId:'0',
                gatewayAddress:null,
                gateway:{
                    floorId:'0',
                    roomId:'0',
                    gatewayId:'0',
                },
                gatewayArr:[],
                gatewayDataList:[],
                gatewayDataIdList:[],

                currentPage:1,
                pageSize:20,
                total:0,


                gatewayTkShowbg:false,
                gatewayTkShow:false,

                
                gatewayUpdateTkShowbg:false,
                gatewayUpdateTkShow:false,
                uploadGatewayVal:0,
                gatewayUpdateType:'1',
                gatewayUpdateSoftware:'',
                gatewayUpdateVersion:'',
                gatewayUpdateStatus:'1',

                networkingTkShowbg:false,
                networkingTkShow:false,
                networkingType:'2',
                networkingType1:false,
                networkingType2:false,
                networkingType3:false,
                isGetDevicesList:false,
                gatewayForm:{
                    id:'',
                    network_name:'',
                    gatewayId:'',
                    floorId:'',
                    roomId:'',
                    inspecTime:'',
                    type:'0',
                },
                /*wifi*/
                wifiTkShowbg:false,
                wifiTkShow:false,
                wifiText1:'Please connect to WiFi',
                wifiSsidForm:{
                    wifiName:'',
                    wifiPw:'',
                },
                wifiSsidNav:[],
                wifiType:'1',
                wifiStatus:'0',
                uploadWifiVal:0,

                inspecTimeNav:[],
                gatewayOnline:'',

                connectList:[],
                devicesList:[],
                devices_485_List:[],

                devType:[],
                devTypeOptions:[],

                loading:{
                    connectList:false,
                    devicesList:false,
                    devices_485_List:false,
                    gatewayDataList:false,
                    wifiFun:false,
                    getWifiList:false,
                    netLamp:false,
                },
                websocket1:null,
                websocket2:null,
                status_:null,

                img_str:'',
                img_gateway_icon:'',
                
                updateRemRatioShakeProof:null,
            }
        },
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',

                remRatio:'remRatio',
                updateRemRatio:'updateRemRatio',

                countryId:'countryId',
                provinceId:'provinceId',
                cityId:'cityId',
                hotelId:'hotelId',
                headerIdStr:'headerIdStr',
            }),
            gatewayFormFloorName(){
                let name = '';
                if(this.floorNav.length>0){
                    for(let d of this.floorNav){
                        if(d.id == this.gatewayForm.floorId){
                            name = d.name;
                        }
                    }
                }else{
                    name = this.$t('App.gateway.text20')
                }
                return name
            },
            gatewayFormType(){
                let name = '';
                if(this.formTypeNav.length>0){
                    for(let d of this.formTypeNav){
                        if(d.id == this.gatewayForm.type){
                            name = d.name;
                        }
                    }
                }else{
                    name = this.$t('App.gateway.text20')
                }
                return name
            },
            
            gatewayFormRoomName(){
                let name = '';
                if(this.roomNav.length>0){
                    for(let d of this.roomNav){
                        if(d.id == this.gatewayForm.roomId){
                            name = d.number;
                        }
                    }
                }else{
                    name = this.$t('App.gateway.text20')
                }
                return name
            },
            gatewayFormInspecTime(){
                let name = '';
                if(this.inspecTimeNav.length>0){
                    for(let d of this.inspecTimeNav){
                        if(d.id == this.gatewayForm.inspecTime){
                            name = d.name;
                        }
                    }
                }else{
                    name = this.$t('App.gateway.text20')
                }
                return name
            },
            // wifiSsidName(){
            //     let name = '';
            //     for(let d of this.wifiSsidNav){
            //         if(d.id == this.wifiSsidForm.ssid){
            //             name = d.name;
            //         }
            //     }
            //     return name
            // }
        },
        components:{
            // 'sideBar':sideBar
        },
        beforeDestroy(){
            if(this.websocket1){
                this.websocket1.close();
            }
            if(this.websocket2){
                this.websocket2.close();
            }
        },
        mounted(){
            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:true,
            })

            this.wifiText1 = this.$t('App.gateway.text19');

            this.img_gateway_icon = require('../img/gateway_icon.png');
            if(this.version == '1'){
                this.img_gateway_icon = require('../img/gateway_icon_v1.png');
                this.img_str = '_v1'
            }
            this.gatewayArr = [
                {prop:'floor',label:this.$t('App.room.text29'),minWidth:5*this.remRatio},
                {prop:'roomNumber',label:this.$t('App.room.text30'),minWidth:5*this.remRatio},
                {prop:'online',label:this.$t('App.lights.text30'),minWidth:8*this.remRatio,type:1},
                {prop:'firmware',label:this.$t('App.lights.text11'),minWidth:8.5*this.remRatio},
                {prop:'software',label:this.$t('App.lights.text12'),minWidth:8.5*this.remRatio},
            ];
            this.formTypeNav = [
                {id:'0',name:'weclouds'},
                {id:'1',name:'GS200'},
            ];
            this.devTypeOptions = [
                {
                    value: '4',
                    label: this.$t('App.sideBar.text3'),
                    children: [
                        {
                            value: '0',
                            label: 'EL-DP02-1200-LY',
                        },
                        {
                            value: '1',
                            label: 'EL-DP03-1200-LY',
                        },
                        {
                            value: '2',
                            label: 'EL-WKDP03-1200-LY',
                        },
                    ]
                },
                {
                    value: '5',
                    label: this.$t('App.sideBar.text4'),
                    children: [
                        {
                            value: '0',
                            label: 'EL-HZJ01-1200-LY',
                        }
                    ]
                },
                {
                    value: '6',
                    label: this.$t('App.sideBar.text6')
                },
                {
                    value: '7',
                    label: this.$t('App.sideBar.text5')
                },
            ];
            if(this.hotelId){
                this.getBuildNav(()=>{
                    if(this.buildNav.length > 0){
                        this.buildId = this.buildNav[0].id;
                        this.getGatewayList();
                    }else{
                        this.buildId = '';

                        this.gatewayDataList = [];
                        this.total = 0;
                        this.gatewayDataIdList = [];
                        this.checkList = [];
                        this.isIndeterminate = false;
                    }
                });
            }
            this.getInspecTimeNav();

            base.websocket_close(allUrl.websocket.ws,websocket=>{
                // console.log(websocket)
                this.websocket2 = websocket;
                websocket.send('{"type":"cmd"}');
                websocket.onmessage = event => {
                    console.log(JSON.parse(event.data));
                    let data = JSON.parse(event.data)
                    if(data.code == '0000'){
                        if(data.data.status == '1'){
                            this.clientid = data.data.clientid
                        }
                        if(data.data.status == '2'){
                            if(data.data.type == 'statusControl'){
                                this.$notify({
                                    title: data.msg,
                                    message: this.$t('App.message.text22')+data.data.name,
                                    type: 'success'
                                });
                                for(let d of this.connectList){
                                    if(d.id == data.data.id){
                                        d.loading2 = false;
                                        this.loading.netLamp = false;
                                        // d.status = false;
                                    }
                                }
                            }
                        }
                    }else{
                        this.$alert(data.msg, this.$t('App.message.text1'), {
                            confirmButtonText: this.$t('App.message.text2'),
                        });
                        if(data.data.type == 'statusControl'){
                            for(let d of this.connectList){
                                if(d.id == data.data.id){
                                    d.loading2 = false;
                                    this.loading.netLamp = false;
                                    d.status = this.status_;
                                }
                            }
                        }
                    }
                }
            },this)
        },
        methods:{
            devTypeChange(obj){
                let type = obj.devType[0];
                let model = obj.devType[1];
                obj.devTypeLoading = true;
                base.ajax_post(
                    allUrl.smartCampus.charge_dev_type,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        id:obj.id,
                        type:type,
                        model:model,
                    },
                    {},
                    data=>{
                        // console.log(data)
                        obj.devTypeLoading = false;
                        this.$message({
                            showClose: true,
                            message: data.msg,
                            type: 'success'
                        });
                    },
                    this,()=>{
                        obj.devTypeLoading = false;
                    }
                )
            },
            switchWifiFun(){
                this.wifiType = '1';
                this.wifiStatus = '0';
                this.wifiText1 = this.$t('App.gateway.text19');
                this.wifiSsidForm.wifiName = '';
                this.wifiSsidForm.wifiPw = '';
            },
            wifiFun(){
                if(this.wifiStatus == '1'||this.loading.wifiFun){
                    return
                }
                if(!this.wifiSsidForm.wifiName){
                    this.$notify({
                        message: this.$t('App.gateway.text21'),
                        type: 'warning'
                    });
                    return
                }
                // if(!this.wifiSsidForm.wifiPw){
                //     this.$notify({
                //         message: this.$t('App.gateway.text22'),
                //         type: 'warning'
                //     });
                //     return
                // }
                this.wifiType = '1';
                this.loading.wifiFun = true;
                base.ajax_post(
                    allUrl.gateway.setWifi,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        id:this.gatewayId,
                        wifiName:this.wifiSsidForm.wifiName,
                        wifiPw:this.wifiSsidForm.wifiPw,
                    },
                    {},
                    ()=>{
                        this.loading.wifiFun = false;
                        // this.wifiName = data.data.wifiName;
                        this.wifiStatus = '1';
                        this.wifiType = '3';
                        this.wifiText1 = this.$t('App.gateway.text23');
                    },
                    this,()=>{
                        this.loading.wifiFun = false;
                        this.wifiStatus = '0';
                        this.wifiType = '3';
                        this.wifiText1 = this.$t('App.gateway.text24');
                    }
                )
            },
            wifiSsidCommand(val){
                this.wifiSsidForm.wifiName = val;
            },
            openWifiFun(obj){
                if(obj.online == 0){
                    this.$notify({
                        message: this.$t('App.gateway.text25'),
                        type: 'warning'
                    });
                    return
                }
                this.wifiType = '1';
                this.wifiStatus = '0';
                this.wifiText1 = this.$t('App.gateway.text19');
                this.gatewayId = obj.id;
                this.wifiSsidForm.wifiName = '';
                this.wifiSsidForm.wifiPw = '';

                this.wifiTkShowbg = true;

                base.ajax_post(
                    allUrl.gateway.getWifiName,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        id:obj.id,
                    },
                    {},
                    data=>{
                        this.wifiTkShow = true;
                        this.wifiSsidForm.wifiName = data.data.wifiName;
                    },
                    this,()=>{
                        this.wifiTkShowbg = false;
                    }
                )
                this.loading.getWifiList = true;
                base.ajax_post(
                    allUrl.gateway.getWifiList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        id:obj.id,
                    },
                    {},
                    data=>{
                        this.loading.getWifiList = false;
                        this.wifiSsidNav = data.data.list;
                    },
                    this,()=>{
                        this.loading.getWifiList = false;
                    }
                )
            },
            wifiTkClose(){
                let this_ = this;
                this.wifiTkShow = false;
                setTimeout(function(){
                    this_.wifiTkShowbg = false;
                },400)
            },

            commandHide(val){
                this.$nextTick(function(){
                    if($('.'+val)&&$('.'+val+' >.select').offset()){
                        $('.'+val).animate({scrollTop: $('.'+val).scrollTop() + $('.'+val+' >.select').offset().top - $('.'+val).offset().top - 100})
                    }
                })
            },
            commandInspecTime(data){
                this.gatewayForm.inspecTime = data.id;
            },
            getInspecTimeNav(){
                base.ajax_post(
                    allUrl.gateway.inspecTimeNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                    },
                    {},
                    data=>{
                        this.inspecTimeNav = data.data.list;
                    },
                    this
                )
            },
            /*灯闪烁*/
            statusControl(obj){
                console.log(obj)
                this.status_ = obj.status;
                if(obj.status == '0'){
                    obj.status = '1'
                }else{
                    obj.status = '0'
                }
                if(!obj.loading2){
                    if(!this.loading.netLamp){
                        this.loading.netLamp = true;
                    }else{
                        this.$message(this.$t('App.mmessage.text38'));
                        return
                    }
                    obj.loading2 = true;
                    base.ajax_postWs(
                        allUrl.gateway.statusControl,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            lampId:obj.id,
                            gatewayId:obj.gatewayId,
                            status:obj.status,
                            clientId:this.clientid,
                        },
                        this
                    )
                }
            },
            /*设备绑定网关*/
            addNetLamp(obj,bind){
                let this_ = this;
                if(!obj.loading1){
                    if(!this.loading.netLamp){
                        this.loading.netLamp = true;
                    }else{
                        this.$message(this.$t('App.message.text38'));
                        return
                    }
                    obj.loading1 = true;
                    base.websocket(allUrl.websocket.ws,websocket=>{
                        websocket.send('{"type":"cmd"}');
                        websocket.onmessage = event => {
                            if (event.data) {
                                try {
                                    let data = JSON.parse(event.data)
                                    if (data.code == '0000'&&data.data.status == 1) {
                                        base.ajax_postWs(
                                            allUrl.gateway.addNetLamp,
                                            {
                                                username:this.username,
                                                client_key:this.client_key,
                                                token:this.token,

                                                clientId:data.data.clientid,
                                                deviceId:obj.deviceId,
                                                fettle:obj.fettle,
                                                gatewayId:this.gateway.gatewayId,
                                                bind:bind,
                                            },
                                            this
                                        )
                                    }
                                    if (data.data.status == 2) {
                                        if(data.code == '0000'){
                                            this.$message({
                                              showClose: true,
                                              message: data.msg,
                                              type: 'success'
                                            });
                                            if(obj.fettle == 1){
                                                if(bind == 1){
                                                    this.devicesList.splice(this.devicesList.indexOf(obj),1)
                                                    if(this.devicesList.length == 0){
                                                        this['networkingType2'] = false;
                                                    }
                                                    // this.connectList.push(obj)
                                                }else{
                                                    this.connectList.splice(this.connectList.indexOf(obj),1)
                                                    if(this.connectList.length == 0){
                                                        this['networkingType1'] = false;
                                                    }
                                                    // this.devicesList.push(obj)
                                                }
                                            }else{
                                                if(bind == 1){
                                                    this.devices_485_List.splice(this.devices_485_List.indexOf(obj),1)
                                                    if(this.devices_485_List.length == 0){
                                                        this['networkingType3'] = false;
                                                    }
                                                    // this.connectList.push(obj)
                                                }else{
                                                    this.connectList.splice(this.connectList.indexOf(obj),1)
                                                    if(this.connectList.length == 0){
                                                        this['networkingType1'] = false;
                                                    }
                                                    // this.devices_485_List.push(obj)
                                                }
                                            }
                                            // this.getDevicesList(this.gateway,'2')
                                            // this.getDevicesList(this.gateway,'1')
                                            // this.getDevicesList(this.gateway,'3')
                                        }else{
                                            this_.$alert(data.msg, this_.$t('App.message.text1'), {
                                                confirmButtonText: this_.$t('App.message.text2'),
                                            });
                                        }
                                        obj.loading1 = false;
                                        this.loading.netLamp = false;
                                        websocket.close();
                                    }
                                } catch (e) {
                                    obj.loading1 = false;
                                    this.loading.netLamp = false;
                                    console.log(e)
                                }
                            }
                        };
                    },this)
                }
            },
            /*设备列表*/
            getDevicesList(obj,type){
                this['networkingType'+type] = true;
                let isTrue = false;

                if(!this.loading.connectList&&type == '1'){
                    isTrue = true;
                }
                if(!this.loading.devicesList&&type == '2'){
                    isTrue = true;
                }
                if(!this.loading.devices_485_List&&type == '3'){
                    isTrue = true;
                }
                if(isTrue){
                    if(type == '1'){
                        this.loading.connectList = true;
                    }
                    if(type == '2'){
                        this.loading.devicesList = true;
                    }
                    if(type == '3'){
                        this.loading.devices_485_List = true;
                    }

                    base.ajax_post(
                        allUrl.gateway.getLamp,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            floorId:obj.floorId,
                            roomId:obj.roomId,
                            gatewayId:obj.gatewayId,
                            bindLamp:type,
                        },
                        {},
                        data=>{
                            for(let d of data.data.list){
                                this.$set(d,'loading1',false)
                                this.$set(d,'loading2',false)
                            }
                            this.loading.netLamp = false;
                            if(type == '1'){
                                this.connectList = data.data.list
                                for(let d of this.connectList){
                                    this.$set(d,'devTypeLoading',false)
                                    if(d.type == '4'||d.type == '5'){
                                        this.$set(d,'devType',[d.type,d.model])
                                    }
                                    if(d.type == '6'||d.type == '7'){
                                        this.$set(d,'devType',[d.type])
                                    }
                                }
                                this.loading.connectList = false;
                            }
                            if(type == '2'){
                                this.devicesList = data.data.list;
                                this.loading.devicesList = false;
                            }
                            if(type == '3'){
                                this.devices_485_List = data.data.list;
                                this.loading.devices_485_List = false;
                            }
                        },
                        this,
                        ()=>{
                            if(type == '1'){
                                this.connectList = [];
                                this.loading.connectList = false;
                            }
                            if(type == '2'){
                                this.devicesList = [];
                                this.loading.devicesList = false;
                            }
                            if(type == '3'){
                                this.devices_485_List = [];
                                this.loading.devices_485_List = false;
                            }

                        }
                    )
                }
            },
            networkingFun(obj){
                if(obj.online == '1'){
                    this.gatewayId = obj.id;
                    this.networkingTkShowbg = true;
                    this.$nextTick(function(){
                        this.networkingTkShow = true;
                    })
                    this.gateway.gatewayId = obj.gatewayId;
                    this.gateway.floorId = obj.floorId;
                    this.gateway.roomId = obj.roomId;
                    this.isGetDevicesList = true;

                    // this.getDevicesList(obj,'1');
                    this.getDevicesList(obj,this.networkingType);
                    // this.getDevicesList(obj,'3');
                }else{
                    this.$message({
                        message: this.$t('App.gateway.text25'),
                        type: 'warning'
                    });
                    
                }
            },
            networkingTkClose(){
                let this_ = this;
                this.networkingTkShow = false;
                setTimeout(function(){
                    this_.networkingTkShowbg = false;
                    this_.connectList = [];
                    this_.devicesList = [];
                    this_.devices_485_List = [];
                    this_.networkingType1 = false;
                    this_.networkingType2 = false;
                    this_.networkingType3 = false;
                },400)
            },
            networkingTypeFun(val){
                // console.log(this.gateway)
                this.networkingType = val;
                if(!this['networkingType'+val]){
                    this['networkingType'+val] = true;
                    this.getDevicesList(this.gateway,this.networkingType);
                }
            },

            gatewayUpdateFun(){
                if(this.gatewayUpdateStatus == '1'||this.gatewayUpdateType == '2'){
                    base.websocket(allUrl.websocket.ws,websocket=>{
                        this.websocket1 = websocket;
                        websocket.send('{"type":"updateNetwork","gatewayId":"'+this.gatewayAddress+'"}');
                        websocket.onmessage = event => {
                            // console.log(JSON.parse(event.data));
                            let data = JSON.parse(event.data)
                            if(data.code == '0000'){
                                if(data.data.status == '1'){
                                    this.clientid = data.data.clientid
                                    base.ajax_postWs(
                                        allUrl.gateway.updateFire,
                                        {
                                            username:this.username,
                                            client_key:this.client_key,
                                            token:this.token,
                                            id:this.gatewayId,
                                            type:'0',
                                            clientId:this.clientid,
                                        },
                                        this
                                    )
                                    this.uploadGatewayVal = 0;
                                    this.gatewayUpdateType = '2';
                                }
                                if(data.data.status == '2'){
                                    if(data.data.type == 'updateNetwork'){
                                        this.uploadGatewayVal = data.data.step;
                                        if(this.uploadGatewayVal>=100){
                                            this.gatewayUpdateType = '3';
                                            this.gatewayUpdateStatus = '1';
                                        }
                                    }
                                }
                            }else{
                                this.$alert(data.msg, this.$t('App.message.text1'), {
                                    confirmButtonText: this.$t('App.message.text2'),
                                });
                                if(data.data.status == '2'){
                                    if(data.data.type == 'updateNetwork'){
                                        this.uploadGatewayVal = 0;
                                        this.gatewayUpdateType = '3';
                                        this.gatewayUpdateStatus = '0';
                                    }
                                }
                            }
                        }
                    })
                }
            },
            upgradeFun(obj){
                if(obj.online == 0){
                    this.$notify({
                        message: this.$t('App.gateway.text25'),
                        type: 'warning'
                    });
                    return
                }
                this.gatewayUpdateTkShowbg = true;
                this.gatewayUpdateSoftware = obj.software;
                this.gatewayId = obj.id;
                this.gatewayAddress = obj.gatewayId;

                this.gatewayUpdateType = '1';
                this.gatewayUpdateStatus = '1';
                base.ajax_post(
                    allUrl.gateway.checkUpdate,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        id:obj.id,
                        type:'0',
                    },
                    {},
                    data=>{
                        if(data.data.status == '1'){
                            this.gatewayUpdateTkShow = true;
                            this.gatewayUpdateVersion = data.data.version
                        }else{
                            this.gatewayUpdateTkShowbg = false;
                            this.$notify({
                                message: data.data.version+this.$t('App.message.text10'),
                                type: 'success'
                            });
                        }
                    },
                    this,()=>{
                        this.gatewayUpdateTkShowbg = false;
                    }
                )
            },
            gatewayUpdateTkClose(){
                let this_ = this;
                this.gatewayUpdateTkShow = false;
                setTimeout(function(){
                    this_.gatewayUpdateTkShowbg = false;
                },400)
            },
            /*编辑设备*/
            editFun(item){
                this.gatewayOnline = item.online;
                this.gatewayTkShowbg = true;
                this.gatewayId = item.id;
                this.gatewayForm.id = item.id;
                this.gatewayForm.network_name = item.network_name;
                this.gatewayForm.gatewayId = item.gatewayId;
                this.gatewayForm.inspecTime = item.inspecTime;
                this.getFloorNav(()=>{
                    this.gatewayForm.floorId = item.floorId
                    this.getRoomNav(()=>{
                        this.gatewayForm.roomId = item.roomId
                    });
                })
                this.$nextTick(function(){
                    this.gatewayTkShow = true;
                })
            },
            /*添加设备*/
            addGatewayFun(){
                this.gatewayTkShowbg = true;
                for(let key in this.gatewayForm){
                    this.gatewayForm[key] = '';
                }
                this.gatewayForm.type = '0';
                this.gatewayId = '0';
                this.getFloorNav(()=>{
                    if(this.floorNav.length > 0){
                        this.gatewayForm.floorId = this.floorNav[0].id;
                        this.getRoomNav(()=>{
                            if(this.roomNav.length > 0){
                                this.gatewayForm.roomId = this.roomNav[0].id;
                            }
                        });
                    }
                })
                this.$nextTick(function(){
                    this.gatewayTkShow = true;
                })
            },
            gatewayTkClose(){
                let this_ = this;
                this.gatewayTkShow = false;
                setTimeout(function(){
                    this_.gatewayTkShowbg = false;
                },400)
            },
            commandFloor(data){
                this.gatewayForm.floorId = data.id;
                this.getRoomNav(()=>{
                    this.gatewayForm.roomId = '';
                });
                this.gatewayForm.roomId = '';
            },
            commandType(data){
                this.gatewayForm.type = data.id;
            },
            
            commandRoom(data){
                this.gatewayForm.roomId = data.id;
            },
            postSaveGateway(){
                let this_ = this;
                base.ajax_post(
                    allUrl.gateway.addRoomNet,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        id:this.gatewayId,
                        ...this.gatewayForm
                    },
                    {},
                    data=>{
                        this.getGatewayList();
                        this.gatewayTkShow = false;
                        setTimeout(function(){
                            this_.gatewayTkShowbg = false;
                        },400)
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                    },
                    this
                )
            },
            /*删除设备*/
            postDelLight(obj,type){
                let gatewayId = '',isTrue = true;
                if(type == 'batch'){
                    if(obj.length == 0){
                        isTrue = false;
                        this.$message({
                            message: this.$t('App.message.text23'),
                            type: 'warning'
                        });
                    }else{
                        for(let id of obj){
                            if(gatewayId == ''){
                                gatewayId = id;
                            }else{
                                gatewayId += ','+id;
                            }
                        }
                    }
                }else{
                    gatewayId = obj.id;
                }
                if(isTrue){
                    this.$confirm(
                        this.$t('App.message.text24'), this.$t('App.message.text17'), {
                            confirmButtonText: this.$t('App.message.text2'),
                            cancelButtonText: this.$t('App.message.text6'),
                            type: 'warning'
                        }
                    ).then(() => {
                        base.ajax_post(
                            allUrl.gateway.delRoomNet,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                id:gatewayId,
                            },
                            {},
                            data=>{
                                this.$message({
                                  showClose: true,
                                  message: data.msg,
                                  type: 'success'
                                });
                                this.getGatewayList();
                            },
                            this
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('App.message.text18')
                        });          
                    });
                }
            },
            /*设备列表*/
            getGatewayListKeyUp(e){
                if(e.key == 'Enter'){
                  this.getGatewayList();
                }
            },
            getGatewayList(callback){
                if(this.buildId){
                    this.loading.gatewayDataList = true;
                    base.ajax_post(
                        allUrl.gateway.getlist,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            buildId:this.buildId,
                            // roomId:this.roomId,
                            page:this.currentPage,
                            count:this.pageSize,
                            type:'0',
                            keywords:this.keywords,
                        },
                        {},
                        data=>{
                            this.loading.gatewayDataList = false;
                            this.gatewayDataList = data.data.list;
                            this.total = Number(data.data.total);
                            
                            this.gatewayDataIdList = [];
                            this.checkList = [];
                            this.isIndeterminate = false;
                            this.checkAll = false;

                            let i = 1 + (this.currentPage-1)*this.pageSize;
                            for(let d of this.gatewayDataList){
                                this.gatewayDataIdList.push(d.id);
                                d.webIndex = i;
                                i++;
                            }
                            if(callback){
                                callback(data)
                            }
                            this.$nextTick(function(){
                                this.$refs.gatewayDataList.doLayout();
                            })
                        },
                        this,()=>{
                            this.loading.gatewayDataList = false;
                        }
                    )
                }
            },
            /*楼房下拉列表*/
            getBuildNav(callback){
                if(this.hotelId){
                    base.ajax_post(
                        allUrl.room.buildNav,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            hotelId:this.hotelId,
                        },
                        {},
                        data=>{
                            this.buildNav = data.data.list;
                            if(callback){
                                callback(data)
                            }
                        },
                        this
                    )
                }
            },
            /*楼层下拉列表*/
            getFloorNav(callback){
                base.ajax_post(
                    allUrl.room.floorNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                    },
                    {},
                    data=>{
                        this.floorNav = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*楼间下拉列表*/
            getRoomNav(callback){
                base.ajax_post(
                    allUrl.room.roomNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                        floorId:this.gatewayForm.floorId,
                    },
                    {},
                    data=>{
                        this.roomNav = data.data.list;
                        console.log(this.roomNav)
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.currentPage = 1;
                this.getGatewayList();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getGatewayList();
                // console.log(val)
            },
            handleCheckAllChange(val) {
                this.checkList = val ? this.gatewayDataIdList : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value){
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.gatewayDataIdList.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.gatewayDataIdList.length;
            },
        },
        watch:{
            hotelId:function(){
                if(this.hotelId){
                    this.getBuildNav(()=>{
                        if(this.buildNav.length > 0){
                            this.buildId = this.buildNav[0].id;
                            this.currentPage = 1;
                            this.getGatewayList();
                        }else{
                            this.buildId = '';
                            this.gatewayDataList = [];
                            this.total = 0;
                            this.gatewayDataIdList = [];
                            this.checkList = [];
                            this.isIndeterminate = false;
                        }
                    });
                }
            },
            buildId:function () {
                this.currentPage = 1;
                this.getGatewayList();
            },
            updateRemRatio:function(){
                clearTimeout(this.updateRemRatioShakeProof)
                this.updateRemRatioShakeProof = setTimeout(()=>{
                    this.gatewayArr = [
                        {prop:'floor',label:this.$t('App.room.text29'),minWidth:5*this.remRatio},
                        {prop:'roomNumber',label:this.$t('App.room.text30'),minWidth:5*this.remRatio},
                        {prop:'online',label:this.$t('App.lights.text30'),minWidth:8*this.remRatio,type:1},
                        {prop:'firmware',label:this.$t('App.lights.text11'),minWidth:8.5*this.remRatio},
                        {prop:'software',label:this.$t('App.lights.text12'),minWidth:8.5*this.remRatio},
                    ];
                    this.$nextTick(function(){
                        this.$refs.gatewayDataList.doLayout();
                    })
                },1000)
            }
        }
    }
</script>

<style type="text/css" lang="less">
    .gateway_main{
        width: 100%;
        height: 100%;
        // height: 105rem;
        min-height: 50rem;
        // min-width: 120rem;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        display: flex;
        background: #F6F8FA;
        &.cn{
            .gateway_right{
                .gateway_right_top .right_top_l > .el-input .el-icon-search{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
                .gateway_right_main .main_cont{
                    .el-table .brightness .btn_img .bg{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .el-table .btn:hover i{
                        color: #8266C7;
                    }
                    .pagination_box .el-pager li{
                        &:hover{
                            color: #513C93;
                            background:rgba(130,102,199,0.1);
                        }
                        &.active{
                            color: #FFFFFF;
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                }
            }
            .wifi_wrap .wifi_box .update_box .btn{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
            .networking_wrap .networking_box {
                .box1 .btn.select{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
                .networkingType_2,.networkingType_3{
                    .no_devices .btn{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                }
            }
            .gateway_wrap .gateway_box .btn_box .btn{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
        }
        .gateway_left{
            width: 11.67rem;
            height: 100%;
            min-width: 130px;
        }
        .gateway_right{
            position: relative;
            padding: 1.92rem 1.5rem 0;
            width: calc(100% - 11.67rem);
            height: calc(100%);
            .gateway_right_top{
                display: flex;
                justify-content: space-between;
                .right_top_l{
                    .el-input__inner{
                        height: 2.5rem;line-height: 2.5rem;
                        border-radius: 1.25rem;
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #333333;
                        border-color: #F0F0F0;
                    }
                    .el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-select{
                        width: 11.42rem;
                    }
                    >.el-input{
                        margin-left: 1rem;
                        width: 21rem;
                        .el-icon-search{
                            display: inline-block;
                            top: 0;bottom: 0;
                            right: 0;
                            width: 4rem;
                            background: #05CFAB;
                            border-radius: 1.25rem;
                            cursor: pointer;
                            color: #FFFFFF;
                        }
                        .el-input__suffix{
                            right: 0;
                        }
                    }
                }
            }
            .gateway_right_main{
                height: calc(100% - 6.5rem);
                margin-top: 1rem;
                position: relative;
                background: #FFFFFF;
                border: 1px solid #F0F0F0;
                border-radius: 0.4rem;
                .main_top{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 1.67rem 0;
                    .main_top_l{
                        .div1{
                            margin-top: 1.5rem;
                            font-family: AlibabaPuHuiTiB;
                            font-size: 1.5rem;
                            color: #333333;
                        }
                        .div2{
                            margin-top: 1.33rem;
                            display: flex;
                            .btn{
                                margin-left: 1.29rem;
                                display: flex;align-items: center;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                                cursor: pointer;
                                i{
                                    font-size:0.8rem;
                                    color: #C6CDD5;
                                }
                                span{
                                    margin-left: 0.5rem;
                                }
                            }
                        }
                    }
                    .main_top_r{
                        margin-top: 2.33rem;
                        display: flex;
                        .btn{
                            margin-left: 1rem;
                            height: 2.5rem;line-height: 2.5rem;
                            padding: 0 1.25rem;
                            background: #FFFFFF;
                            border: 1px solid #F0F0F0;
                            border-radius: 1.25rem;
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            img{
                                margin-right: 0.5rem;
                                height: 1rem;
                            }
                        }
                    }
                }
                .main_cont{
                    height: calc(100% - 11rem);
                    margin-top: 0.75rem;
                    .el-checkbox-group{
                        height: 100%;
                    }
                    .el-table{
                        .el-loading-spinner{
                            height: 100%;
                            margin-top: 0;top: 50%;
                        }
                        .el-checkbox{
                            margin-left: 1.1rem;
                        }
                        .btn{
                            padding: 0.5rem;
                            cursor: pointer;
                            &+.btn{
                                margin-left: 0.2rem;
                            }
                            i{
                                color: #A3AFBB;
                                font-size:0.8rem;
                            }
                            &:hover{
                                i{
                                    color: #05CFAB;
                                }
                            }
                        }
                        th{
                            font-weight:initial;
                            height: 3rem;
                            border-top: 1px solid #F0F0F0;
                            border-bottom: 1px solid #F0F0F0;
                            padding: 0;
                            background: #F6F8FA;
                            &>.cell{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                            }
                        }
                        td{
                            padding: 0;
                            height: 3rem;
                            &>.cell,.el-checkbox__label{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                            }
                        }
                        .alerts{
                            .text_1{
                                color: rgba(255,12,77,1);
                                i{
                                    margin-left: 0.2rem;
                                    font-size:1rem;
                                }
                            }   
                        }
                        .online{
                            .iconfont{
                                font-size: 1.2rem;
                            }
                        }
                    }
                    .pagination_box{
                        .el-pagination{
                            float: right;
                            margin-top: 0.5rem;
                        }
                        height: 2.5rem;line-height: 2.5rem;
                        .btn-prev .el-icon{
                            font-size:1rem;
                            color: #666666;
                            font-family: PingFang-SC-Medium;
                        }
                        button{
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                        }
                        .el-pager li{
                            margin-left: 0.83rem;
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                            &:hover{
                                color: rgba(5,207,171,1);
                                background-color: rgba(5,207,171,0.1);
                            }
                        }
                        .btn-next{
                            margin-left: 0.83rem;
                        }
                        .el-pager li.active{
                            background: #05CFAB;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
        .gateway_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            // overflow: hidden;
            .gateway_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            .gateway_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.gateway_tk_show{
                    right: 0rem; 
                }
                .gateway_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .gatewayUpdate_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .gatewayUpdate_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .gatewayUpdate_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.gateway_tk_show{
                    right: 0rem; 
                }
                .gatewayUpdate_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .box1{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width:calc(100% - 5rem);
                    height:5.08rem;
                    margin:2.5rem auto 0;
                    padding: 0 1.5rem;
                    background:rgba(246,248,247,1);
                    img{
                        height: 3rem;
                    }
                    span{
                        font-size:1.67rem;
                        font-family:AlibabaPuHuiTiH;
                        color:rgba(51,51,51,1);
                    }
                }
                .p1{
                    width:calc(100% - 5rem);
                    margin:0.75rem auto 0;
                    height:1.42rem;
                    line-height:1.42rem;
                    font-size:1rem;
                    font-family:AlibabaPuHuiTiR;
                    color:rgba(101,112,133,1);
                }
                .btn_box{
                    width:calc(100% - 5rem);
                    margin:2rem auto 0;
                    height:2.67rem;
                    background:rgba(5, 207, 171, 0.1);
                    .btn{
                        width: 100%;height: 100%;line-height: 2.67rem;
                        text-align: center;
                        background:rgba(5,207,171,1);
                        border-radius:0.17rem;

                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        cursor: pointer;
                    }
                    .el-progress{
                        .el-loading-mask{
                            background: rgba(255,255,255,0.1);
                        }
                        .el-progress-bar__outer{
                            height: 2.67rem;
                            background-color:initial;
                            border-radius: 0;
                            .el-progress-bar__inner{
                                border-radius: 0;
                                background-color:rgba(5, 207, 171, 1);
                            }
                        }
                    }
                    .text{
                        width: 100%;height: 100%;line-height: 2.67rem;
                        text-align: center;
                        border-radius:0.17rem;
                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        &.span1{
                            background-color: rgba(255, 12, 77, 1);
                            cursor:pointer;
                        }
                        &.span2{
                            background-color: rgba(165, 201, 195, 1);
                        }
                    }
                }
            }
        }
        .networking_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .networking_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .networking_box{
                position: absolute;
                width: 38rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -38rem;
                transition: all 0.5s;
                .refresh_box{
                    display: flex;
                    justify-content: flex-end;
                    width: 30rem;
                    margin: 0.5rem auto 0rem;
                    .el-button{
                        padding:0;
                        width: 2.5rem;
                        height: 2.5rem;
                        font-size: 1.2rem;
                    }
                }
                &.gateway_tk_show{
                    right: 0rem; 
                }
                .networking_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .box1{
                    display: flex;
                    width: 35rem;height: 2.75rem;line-height: 2.75rem;
                    background-color:rgba(246, 248, 250, 1);
                    border-radius:1.38rem;
                    margin: 2.8rem auto 0;
                    .btn{
                        flex: 1;
                        text-align: center;
                        font-size:1rem;
                        font-family:AlibabaPuHuiTiR;
                        color:rgba(51,51,51,1);
                        cursor: pointer;
                        &.select{
                            background-color:rgba(5, 207, 171, 1);
                            color:rgba(255,255,255,1);
                            border-radius:1.67rem;
                        }
                    }
                }
                .networkingType_1{
                    height: calc(100% - 13rem);
                    &.null{
                        display: flex;
                        align-items: center;
                    }
                    .no_devices{
                        width: 100%;
                        text-align: center;
                        .img_box{
                            margin: 0 auto 0;
                            width: 11rem;height: 11rem;
                            img{
                                width: 100%;height: 100%;
                            }
                        }
                        p{
                            margin-top: 1rem;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiR;
                            color:rgba(101,112,133,1);
                        }
                        .btn{
                            margin: 1.67rem auto 0;
                            width:9.33rem;
                            height:2.67rem;line-height: 2.67rem;
                            background:rgba(5,207,171,1);
                            border-radius:0.17rem;

                            font-size:1rem;
                            font-family:PingFang-SC-Medium,PingFang-SC;
                            font-weight:500;
                            color:rgba(255,255,255,1);
                            cursor: pointer;
                        }
                    }
                    .list{
                        // margin-top: 3rem;
                        height: 100%;
                        .li{
                            display: flex;
                            justify-content: space-between;
                            margin-bottom: 2.5rem;
                            .l{
                                display: flex;
                                width: calc(100% - 13.6rem);
                            }
                            .img_box{
                                margin-left: 2rem;
                                width: 4.2rem;height: 4.2rem;
                                border-radius: 50%;
                                overflow: hidden;
                                background-color: rgba(246, 248, 250, 1);
                                img{
                                    width: 100%;height: 100%;
                                }
                            }
                            .text_box{
                                margin-left: 1.67rem;
                                .p1{
                                    margin-top: 0.5rem;
                                    line-height: 1.67rem;
                                    font-size:1.17rem;
                                    font-family:AlibabaPuHuiTiR;
                                    color:rgba(51,51,51,1);
                                }
                                .p2{
                                    display: flex;
                                    align-items: center;
                                    font-size:1rem;
                                    font-family:AlibabaPuHuiTiR;
                                    color:rgba(101,112,133,1);
                                    line-height:1.42rem;
                                    i{
                                        margin: 0rem 0.8rem 0;
                                        display: inline-block;
                                        width: 0.15rem;
                                        height: 0.8rem;
                                        background-color:rgba(235, 239, 242, 1);
                                    }
                                    .span2{
                                        display: inline-block;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }
                                }
                            }
                            .r{
                                display: flex;
                                align-items: center;
                                .el-cascader{
                                    width: calc(100% - 5rem);
                                    line-height:2.5rem;
                                    margin-right: 1rem;
                                    .el-input__inner{
                                        border: none;
                                        background-color:rgba(246, 248, 250, 1);
                                        height: 2.5rem;line-height:2.5rem;
                                        font-size: 1rem;
                                        padding:0 2rem 0 1rem;
                                    }
                                    .el-input__icon{
                                        line-height:2.5rem;
                                    }
                                    .el-input__suffix{
                                        right: 0;
                                        .el-input__icon{
                                            width: 2rem;
                                            height: 2.5rem;
                                            font-size: 1rem;
                                        }
                                    }
                                }
                                .btn{
                                    width: 2.5rem;height: 2.5rem;
                                    text-align:center;
                                    border-radius: 50%;
                                    color:rgba(101, 112, 133, 1);
                                    background-color:rgba(246, 248, 250, 1);
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    cursor: pointer;
                                    &:hover{
                                        i{
                                            color: #05CFAB;
                                        }
                                    }
                                }
                                .btn1{
                                    margin-right: 1.5rem;
                                    &.select{
                                        color: #fff;
                                        background-color:rgba(5, 207, 171, 1);
                                    }
                                    .iconfont{
                                        font-size: 1rem;
                                    }
                                }
                                .btn2{
                                    margin-right: 1.6rem;
                                    width: 2.5rem;height: 2.5rem;
                                    &.select{
                                        width: 2.25rem;height: 2.25rem;
                                        border: 0.25rem solid rgba(255, 219, 0, 0.16);
                                        background-color:rgba(255, 219, 0, 1);
                                        color: #fff;
                                    }
                                    .iconfont{
                                        font-size: 1.3rem;
                                    }
                                }
                            }
                        }
                    }
                }
                .networkingType_2,.networkingType_3{
                    height: calc(100% - 13rem);
                    &.null{
                        display: flex;
                        align-items: center;
                    }
                    .no_devices{
                        width: 100%;
                        text-align: center;
                        .img_box{
                            margin: 0 auto 0;
                            width: 11rem;height: 11rem;
                            img{
                                width: 100%;height: 100%;
                            }
                        }
                        p{
                            margin-top: 1rem;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiR;
                            color:rgba(101,112,133,1);
                        }
                        .btn{
                            margin: 1.67rem auto 0;
                            width:9.33rem;
                            height:2.67rem;line-height: 2.67rem;
                            background:rgba(5,207,171,1);
                            border-radius:0.17rem;

                            font-size:1rem;
                            font-family:PingFang-SC-Medium,PingFang-SC;
                            font-weight:500;
                            color:rgba(255,255,255,1);
                            cursor: pointer;
                        }
                    }
                    .list{
                        // margin-top: 3rem;
                        height: 100%;
                        .li{
                            display: flex;
                            justify-content: space-between;
                            margin-bottom: 2.5rem;
                            .l{
                                display: flex;
                                width: calc(100% - 4.5rem);
                            }
                            .img_box{
                                margin-left: 3rem;
                                width: 4.2rem;height: 4.2rem;
                                position: relative;
                                .img_box_{
                                    background-color: rgba(248, 248, 250, 1);
                                    border-radius: 50%;
                                    overflow: hidden;
                                    width: 100%;height: 100%;
                                    img{
                                        width: 100%;height: 100%;
                                    }
                                }
                                .icon{
                                    background-color: #fff;
                                    position: absolute;
                                    right: 0rem;bottom: 0rem;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    width: 1.5rem;height: 1.5rem;
                                    border-radius: 50%;
                                    border: 1px solid rgba(235, 239, 242, 1);
                                    box-sizing: border-box;
                                    img{
                                        width: 1rem;height: 1rem;
                                    }
                                }
                            }
                            .text_box{
                                margin-left: 1.67rem;
                                .p1{
                                    margin-top: 0.5rem;
                                    line-height: 1.67rem;
                                    font-size:1.17rem;
                                    font-family:AlibabaPuHuiTiR;
                                    color:rgba(51,51,51,1);
                                }
                                .p2{
                                    display: flex;
                                    align-items: center;
                                    font-size:1rem;
                                    font-family:AlibabaPuHuiTiR;
                                    color:rgba(101,112,133,1);
                                    line-height:1.42rem;
                                    i{
                                        margin: 0.2rem 0.8rem 0;
                                        display: inline-block;
                                        width: 0.15rem;
                                        height: 0.8rem;
                                        background-color:rgba(235, 239, 242, 1);
                                    }
                                    .span2{
                                        display: inline-block;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }
                                }
                            }
                            .r{
                                display: flex;
                                align-items: center;
                                .btn{
                                    width: 2.5rem;height: 2.5rem;
                                    text-align:center;
                                    border-radius: 50%;
                                    color:rgba(101, 112, 133, 1);
                                    background-color:rgba(246, 248, 250, 1);
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    cursor: pointer;
                                    &:hover{
                                        i{
                                            color: #05CFAB;
                                        }
                                    }
                                }
                                .btn1{
                                    margin-right: 1.6rem;
                                    &.select{
                                        color: #fff;
                                        background-color:rgba(5, 207, 171, 1);
                                    }
                                    .iconfont{
                                        font-size: 1rem;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .wifi_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .wifi_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .wifi_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.wifi_tk_show{
                    right: 0rem; 
                }
                .wifi_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .box1{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width:calc(100% - 5rem);
                    height:5.08rem;
                    margin:2.5rem auto 1.67rem;
                    padding: 0 1.5rem;
                    background:rgba(246,248,247,1);
                    img{
                        height: 3rem;
                    }
                    span{
                        font-size:1.33rem;
                        font-family:AlibabaPuHuiTiM;
                        color:rgba(51,51,51,1);
                    }
                }
                .form_item{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 3.33rem;line-height: 3.33rem;
                    margin: 0 2.5rem 1.67rem;
                    padding: 0 1.67rem 0 1.08rem;
                    background: #F6F8F7;
                    opacity: 1;
                    transition: all 3s;
                    .laber{
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #333333;
                    }
                    .el-dropdown{
                        cursor: pointer;
                        i{
                            margin-left: 1.67rem;
                        }
                    }
                    .el-select{
                        width: calc(100% - 8rem);

                        .el-input{
                            width: calc(100%);
                        }
                    }
                    .el-input{
                        width: calc(100% - 8rem);
                        .el-input__inner{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #657085;
                            text-align: right;
                            background: initial;
                            border: none;
                        }
                    }
                    .el-loading-spinner{
                        height: 100%;
                        top: 0;margin-top: 0;
                        .circular{
                            height: 100%;width: 50%;
                        }
                    }
                }
                .p1{
                    width:calc(100% - 2.5rem);
                    margin:0.75rem auto 0;
                    height:1.42rem;
                    line-height:1.42rem;
                    font-size:1rem;
                    font-family:AlibabaPuHuiTiR;
                    color:rgba(101,112,133,1);
                }
                .update_box{
                    width:calc(100% - 2.5rem);
                    margin:2rem auto 0;
                    height:2.67rem;
                    background:rgba(5, 207, 171, 0.1);
                    opacity: 1;
                    transition: all 3s;
                    .btn{
                        width: 100%;height: 100%;line-height: 2.67rem;
                        text-align: center;
                        background:rgba(5,207,171,1);
                        border-radius:0.17rem;

                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        cursor: pointer;
                    }
                    .el-progress{
                        .el-loading-mask{
                            background: rgba(255,255,255,0.1);
                        }
                        .el-progress-bar__outer{
                            height: 2.67rem;
                            background-color:initial;
                            border-radius: 0;
                            .el-progress-bar__inner{
                                border-radius: 0;
                                background-color:rgba(5, 207, 171, 1);
                            }
                        }
                    }
                    .text{
                        width: 100%;height: 100%;line-height: 2.67rem;
                        text-align: center;
                        border-radius:0.17rem;
                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        &.span1{
                            background-color: rgba(255, 12, 77, 1);
                            cursor:pointer;
                        }
                        &.span2{
                            background-color: rgba(165, 201, 195, 1);
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
</style>